module.exports = __webpack_public_path__ + "img/62f1d5f.jpg";